import { defineMessages } from 'react-intl'

const scope = `modules.expense.features.getExpenseApprovalHistory.presenters.expenseApprovalHistoryPresenter`

export default defineMessages({
  buttonLabel: {
    id: `${scope}.buttonLabel`,
    defaultMessage: 'Approval history',
  },
  actionRequest: {
    id: `${scope}.actionRequest`,
    defaultMessage: 'Requested',
  },
  actionFinalApprove: {
    id: `${scope}.actionFinalApprove`,
    defaultMessage: 'Final approved',
  },
  actionDeny: {
    id: `${scope}.actionDeny`,
    defaultMessage: 'Denied',
  },
  actionApproveAndPass: {
    id: `${scope}.actionApproveAndPass`,
    defaultMessage: 'Approved and passed',
  },
  actionResubmit: {
    id: `${scope}.actionResubmit`,
    defaultMessage: 'Resubmitted',
  },
  actionUnknown: {
    id: `${scope}.actionUnknown`,
    defaultMessage: 'Unknown action',
  },
})
